module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "restricted-input"
  }, [_c('label', [_vm._v(_vm._s(_vm.fieldLabel))]), _vm._v(" "), _c('label', {
    staticClass: "instructions-label"
  }, [_vm._v(_vm._s(_vm.instructionsLabel))]), _vm._v(" "), _c('label', {
    class: _vm.getColor('primary'),
    attrs: {
      "data-limit": (_vm.charactersUsed + "/" + _vm.limit)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryInputMessage),
      expression: "primaryInputMessage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isFirstInputRequired
      }),
      expression: "{required: isFirstInputRequired}"
    }],
    class: {
      'restricted-input form-control': true, 'form-control-error': _vm.errors.has('primaryInput')
    },
    attrs: {
      "id": "primaryInput",
      "name": "primaryInput",
      "type": "text",
      "maxlength": _vm.primaryInputLimit,
      "placeholder": _vm.primaryPlaceholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.primaryInputMessage)
    },
    on: {
      "focus": function($event) {
        _vm.enableShowLimit('primary')
      },
      "blur": function($event) {
        _vm.disableShowLimit('primary')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryInputMessage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    class: _vm.getColor('secondary'),
    attrs: {
      "data-limit": (_vm.charactersUsed + "/" + _vm.limit)
    }
  }, [(_vm.dual) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryInputMessage),
      expression: "secondaryInputMessage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isSecondInputRequired
      }),
      expression: "{required: isSecondInputRequired}"
    }],
    class: {
      'restricted-input form-control': true, 'form-control-error': _vm.errors.has('secondaryInput')
    },
    attrs: {
      "id": "secondaryInput",
      "name": "secondaryInput",
      "type": "text",
      "maxlength": _vm.secondaryInputLimit,
      "placeholder": _vm.secondaryPlaceholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.secondaryInputMessage)
    },
    on: {
      "focus": function($event) {
        _vm.enableShowLimit('secondary')
      },
      "blur": function($event) {
        _vm.disableShowLimit('secondary')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryInputMessage = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('primaryInput') || _vm.errors.has('secondaryInput')),
      expression: "errors.has('primaryInput') || errors.has('secondaryInput')"
    }],
    staticClass: "red-text"
  }, [_vm._v("Required")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.charactersUsed === _vm.limit && (_vm.showLimitOnPrimary || _vm.showLimitOnSecondary)),
      expression: "charactersUsed === limit && (showLimitOnPrimary || showLimitOnSecondary)"
    }],
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559abd32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formControls/RestrictedTwoInputs.vue
// module id = 2152
// module chunks = 1